export class ActivityPhoto {
  constructor(form) {
    if (form) {
      this.id = form.id;
      this.name = form.name;
      this.city = form.city;
      this.uaraEventTypeId = form.uaraEventTypeId;
      this.linkToPicture = form.linkToPicture;
      this.beginTime = form.beginTime;
      this.photos = form.photos;
    } else {
      this.clear();
    }
  }

  clear() {
    this.id = '';
    this.name = '';
    this.city = '';
    this.uaraEventTypeId = '';
    this.linkToPicture = '';
    this.beginTime = '';
    this.photos = [];
  }
}
